// extracted by mini-css-extract-plugin
export default {"csvLink":"AllDeductions_csvLink__+Y7Hy","csvLinkWrapper":"AllDeductions_csvLinkWrapper__4F24O"};